/*
 * rheincool — Use-Case-Matcher (Markenvergleich-Handoff, UseCaseMatcher)
 * 5 Zweck-Buttons (Radiogroup aus calc-core) → passende Empfehlungskarte.
 * Liquid rendert alle Karten versteckt, hier wird nur die passende gezeigt.
 * Publiziert { zweck, handle } unter Store-Key 'matcher' — Tabelle und
 * Abschluss-Sektion abonnieren. Tracking: matcher_select, CTA deklarativ.
 */
class RcUseCaseMatcher extends window.RcCalculator {
  init() {
    this.storeKey = 'matcher';
    this.trackPrefix = 'matcher';
    this.lastZweck = null;
    this.cards = this.querySelectorAll('[data-matcher-card]');
    this.fallback = this.querySelector('[data-matcher-fallback]');
    this.stickyValue = this.querySelector('[data-matcher-sticky-value]');
    this.stickyCtaLink = this.querySelector('[data-matcher-sticky-cta]');
  }

  trackParams() {
    return { zweck: this.segmentValue('zweck') };
  }

  fill(template, params) {
    return Object.entries(params).reduce(
      (text, [key, value]) => text.replaceAll(`{${key}}`, value),
      template || ''
    );
  }

  compute() {
    const zweck = this.segmentValue('zweck');
    if (!zweck) return null;
    const card = this.querySelector(`[data-matcher-card][data-zweck="${zweck}"]`);
    return { zweck, handle: card ? card.dataset.handle : null };
  }

  renderResult(result) {
    const i18n = this.config.i18n || {};
    let activeCard = null;

    this.cards.forEach((card) => {
      const matches = card.dataset.zweck === result.zweck;
      card.hidden = !matches;
      if (matches) activeCard = card;
    });
    if (this.fallback) this.fallback.hidden = Boolean(activeCard);

    const activeSegment = this.querySelector(`[data-calc-segment][data-value="${result.zweck}"]`);
    const zweckLabel = activeSegment ? activeSegment.dataset.zweckLabel : result.zweck;

    /* Sticky-CTA (mobil) auf die aktive Empfehlung zeigen lassen */
    if (activeCard) {
      const cardCta = activeCard.querySelector('[data-matcher-cta]');
      const name = activeCard.querySelector('.rc-matcher__name');
      if (this.stickyCtaLink && cardCta) {
        this.stickyCtaLink.setAttribute('href', cardCta.getAttribute('href'));
        this.stickyCtaLink.dataset.rcTrackModell = cardCta.dataset.rcTrackModell || '';
      }
      if (this.stickyValue && name) this.stickyValue.textContent = name.textContent;
      this.announce(
        this.fill(i18n.announce, {
          modell: name ? name.textContent : '',
          zweck: zweckLabel,
        })
      );
    } else {
      if (this.stickyValue) this.stickyValue.textContent = '';
      this.announce(i18n.announceEmpty || '');
    }

    if (result.zweck !== this.lastZweck) {
      this.lastZweck = result.zweck;
      this.track('matcher_select', { zweck: result.zweck });
    }
  }
}

if (!customElements.get('rc-use-case-matcher')) {
  customElements.define('rc-use-case-matcher', RcUseCaseMatcher);
}
